import React, { useCallback, useMemo, useState } from 'react';
import { useRequest } from 'ahooks';
import Panel from '../index';
import { Line } from '@ant-design/charts';
import { Spin } from 'antd';
import { GetGrovernUseRateFourData, GetGrovernUseRateOneData, GetGrovernUseRateThreeData, GetGrovernUseRateTwoData,
  GetGrovernParkUseRateFourData, GetGrovernParkUseRateOneData,GetGrovernParkUseRateTwoData,GetGrovernParkUseRateThreeData} from '@/services/api';
import cn from 'classnames'
import styles from './index.module.scss';
import ImgSource from '@/assets/img/tingchenan/tingcheliyonglv.png'
export interface ParkingUsageProps {
  areaCode?: string;
}

const tabs = ['车行道车位','人行道车位']

const colors = ['#FEC849', '#315AFA', '#00A8FE', '#66CE97', '#3E77D4'];
const KeyCarTable: React.FC<ParkingUsageProps> = ({ areaCode }) => {
  const [activeTab, changeTabIndex] = useState<string>('车行道车位')
  const [maxAngle, setMaxAngle] = useState(360);

  const { data: useRateData={}, loading, error } = useRequest(useCallback(() => {
    return GetGrovernUseRateFourData(areaCode);
  }, [areaCode]), {
    formatResult: res => res.data,
    refreshDeps: [areaCode]
  })
  const { data: useRateData1={} } = useRequest(useCallback(() => {
    return GetGrovernUseRateOneData(areaCode);
  }, [areaCode]), {
    formatResult: res => res.data,
    refreshDeps: [areaCode]
  })
  const { data: useRateData2={} } = useRequest(useCallback(() => {
    return GetGrovernUseRateTwoData(areaCode);
  }, [areaCode]), {
    formatResult: res => res.data,
    refreshDeps: [areaCode]
  })
  const { data: useRateData3={} } = useRequest(useCallback(() => {
    return GetGrovernUseRateThreeData(areaCode);
  }, [areaCode]), {
    formatResult: res => res.data,
    refreshDeps: [areaCode]
  })
 
 const { data: parkuseRateData={}, loading:parkloading, error:error1 } = useRequest(useCallback(() => {
    return GetGrovernParkUseRateFourData(areaCode);
  }, [areaCode]), {
    formatResult: res => res.data,
    refreshDeps: [areaCode]
  })
  console.log(parkuseRateData)
  const { data: parkuseRateData1={} } = useRequest(useCallback(() => {
    return GetGrovernParkUseRateOneData(areaCode);
  }, [areaCode]), {
    formatResult: res => res.data,
    refreshDeps: [areaCode]
  })
  const { data: parkuseRateData2={} } = useRequest(useCallback(() => {
    return GetGrovernParkUseRateTwoData(areaCode);
  }, [areaCode]), {
    formatResult: res => res.data,
    refreshDeps: [areaCode]
  })
  const { data: parkuseRateData3={} } = useRequest(useCallback(() => {
    return GetGrovernParkUseRateThreeData(areaCode);
  }, [areaCode]), {
    formatResult: res => res.data,
    refreshDeps: [areaCode]
  })

  

  if (loading) {
    return (
      <Panel title="停车利用率" >
        <div className="fetch_container" style={{ height: 200 }}>
          <Spin />
        </div>
      </Panel>
    )
  }

  if (error) {
    return (
      <Panel title="停车利用率"  >
        <div className="fetch_container" style={{ height: 200 }}>
          请求错误
        </div>
      </Panel>
    )
  }
  
  const defaultData = {
    today: parkuseRateData2?parkuseRateData2['todayUseRate']:0,
    weekday: parkuseRateData?parkuseRateData['weekendUseRate']:0,
    workday: parkuseRateData3?parkuseRateData3['workDayUseRate']:0,
    yesterday: parkuseRateData1?parkuseRateData1['yesterdayUseRate']:0
  }
  let roadBerthData = {
    today: useRateData2?useRateData2['todayUseRate']:0,
    weekday: useRateData?useRateData['weekendUseRate']:0,
    workday: useRateData3?useRateData3['workDayUseRate']:0,
    yesterday: useRateData1?useRateData1['yesterdayUseRate']:0
  }

  const chartData = [
    { type: '车行道车位', date: '当日', value: Math.round(roadBerthData.today) },
    { type: '车行道车位', date: '昨天', value: Math.round(roadBerthData.yesterday) },
    { type: '车行道车位', date: '工作日', value: Math.round(roadBerthData.workday) },
    { type: '车行道车位', date: '节假日', value: Math.round(roadBerthData.weekday) },
    { type: '人行道车位', date: '当日', value: Math.round(defaultData.today) },
    { type: '人行道车位', date: '昨天', value: Math.round(defaultData.yesterday) },
    { type: '人行道车位', date: '工作日', value: Math.round(defaultData.workday) },
    { type: '人行道车位', date: '节假日', value: Math.round(defaultData.weekday) }
  ];

  return (
    <Panel
      title="停车利用率"
    >
      <div className={styles.container}>
        <Line
          height={200}
          padding={[20, 20, 23, 48]}
          smooth={true}
          data={chartData}
          xField="date"
          yField="value"
          seriesField="type"
          legend={false}
          xAxis={{
            label: {
              style: {
                fill: '#fff'
              }
            },
            line: {
              style: {
                stroke: '#12708D'
              }
            },
            range: [0, 1],
            tickLine: null
          }}
          yAxis={{
            label: {
              style: {
                fill: '#fff'
              },
              formatter: (v: string) => `${v}`
            },
            grid: {
              line: {
                style: {
                  stroke: '#12708D',
                  strokeOpacity: 0.4
                }
              }
            }
          }}
          tooltip={{
            formatter: (datum: any) => {
              return {
                name: datum.type,
                value: datum.value
              }
            },
            showTitle: false
          }}
          animation={{
            appear: {
              animation: 'path-in',
              duration: 3000
            },
            enter: {
              easing: 'easeLinear',
              duration: 3000,
              delay: 2000
            }
          }}
        />
      </div>
    </Panel>
  )
}

export default KeyCarTable;